module.exports = __webpack_public_path__ + "media/images/book-open-black-bf0a901703ca987072fb963b88f73aa2.svg";